module.exports = __webpack_public_path__ + "static/media/亞健康-350.bb3344e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/亞健康-350.gif
// module id = 711
// module chunks = 0